(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector(
          'input[name="locale_code"], input[name="country_code"]'
        ),
        button: this.querySelector("button"),
        panel: this.querySelector("ul"),
      };

      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.elements.button.addEventListener("click", this.togglePanel.bind(this));
      this.addEventListener("keydown", this.onEscapePress.bind(this));

      this.querySelectorAll("a").forEach((item) =>
        item.addEventListener("click", this.onItemClick.bind(this))
      );
    }

    connectedCallback() {
      document.addEventListener("click", this.handleDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener("click", this.handleDocumentClick);
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.hidePanel();
      }
    }

    hidePanel() {
      this.elements.button.setAttribute("aria-expanded", "false");
      this.elements.panel.setAttribute("hidden", true);
    }

    showPanel() {
      this.elements.button.setAttribute("aria-expanded", "true");
      this.elements.panel.removeAttribute("hidden");
    }

    togglePanel() {
      if (this.elements.button.getAttribute("aria-expanded") === "true") {
        this.hidePanel();
      } else {
        this.showPanel();
      }
    }

    onEscapePress(event) {
      if (event.key === "Escape") {
        this.hidePanel();
      }
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector("form")?.submit();
      this.hidePanel();
    }
  }

  if (!customElements.get("localization-form")) {
    customElements.define("localization-form", LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.hasOverlay = this.header.classList.contains('has-overlay');

			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;
			this.predictiveSearch = this.querySelector('predictive-search');

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => this.preventReveal = true;

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);

			this.createObserver();

			if (this.headerIsAlwaysSticky) this.reveal;
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			if (this.header) {
				observer.observe(this.header);
			}
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			const headerTop = document.querySelector(".shopify-section-header .header__top");
			const headerSearch = document.querySelector(".shopify-section-header .search__content");
			const headerBottom = document.querySelector(".shopify-section-header .header__bottom");

			if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
				this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
			};

			if (this.hasOverlay && this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
				this.header.classList.remove('color-background-3');
				headerTop.classList.remove('color-background-3');
				headerBottom?.classList?.remove('color-background-3');
				headerSearch.classList.remove('color-background-3');
				this.header.style.transition = 'background var(--duration-short)';
				this.header.style.transform = 'translateY(0)';
			};

			if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
				this.header.classList.remove('shopify-section-header-sticky');
				if (this.hasOverlay) {
					this.header.style.transform = 'translateY(0)';
					this.header.style.transition = 'background var(--duration-short)';

					if (this.header.classList.contains('color-background-1')) {
						this.header.classList.add('color-background-3');
						headerTop.classList.add('color-background-3');
						headerSearch.classList.add('color-background-3');
						headerBottom?.classList?.add('color-background-3');
					};
				}
			};

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
					this.predictiveSearch.onFocusOut();
					this.predictiveSearch.onBlur();
				}
				if (this.preventHide) return;
				requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this));
				} else {
					window.clearTimeout(this.isScrolling);

					this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
				}
			} else if (scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			const headerTop = document.querySelector(".shopify-section-header .header__top");
			const headerSearch = document.querySelector(".shopify-section-header .search__content");
			const headerBottom = document.querySelector(".shopify-section-header .header__bottom");
      
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
			if(this.hasOverlay) {
				this.header.classList.add('shopify-section-header-sticky', 'animate');
				this.header.classList.remove('shopify-section-header-hidden','color-background-3');
				headerTop.classList.remove('color-background-3');
				headerSearch.classList.remove('color-background-3');
				headerBottom?.classList?.remove('color-background-3');
			}
		}

		reset() {
			if (this.headerIsAlwaysSticky) return;
			const headerTop = document.querySelector(".shopify-section-header .header__top");
			const headerSearch = document.querySelector(".shopify-section-header .search__content");
			const headerBottom = document.querySelector(".shopify-section-header .header__bottom");
      

			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
			if (this.header.classList.contains('color-background-1') && this.hasOverlay) {
				this.header.classList.add('color-background-3');
				headerTop.classList.add('color-background-3');
				headerBottom?.classList?.add('color-background-3');
				headerSearch.classList.add('color-background-3');
			};
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
			if (this.disclosures) {
				this.disclosures.forEach(disclosure => disclosure.close());
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer-hulkapps-backup"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();

      const overlay = this.querySelector('[data-modal-overlay]');
      if (overlay) overlay.addEventListener('click', () => this.hide());

      this.querySelectorAll('[data-modal-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          this.showActiveMedia(thumb.getAttribute('data-media-id'));
        });
      });
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia(this.openedBy.getAttribute('data-media-id'));
    }

    showActiveMedia(mediaId) {
      const activeMedia = this.querySelector(`.product-media-modal__content [data-media-id="${mediaId}"]`);
      if (!activeMedia) return;

      this.querySelectorAll('.product-media-modal__content [data-media-id]').forEach((element) => {
        element.classList.toggle('active', element === activeMedia);
      });

      this.querySelectorAll('[data-modal-thumb]').forEach((thumb) => {
        const isActive = thumb.getAttribute('data-media-id') === mediaId;
        thumb.classList.toggle('is-active', isActive);
        if (isActive) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });

      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  class RelatedProduct extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const related = html.querySelector('.related-product');
            if (related && related.innerHTML.trim().length) {
              this.innerHTML = related.innerHTML;
            }

            /* Toggle content */
            $('.product-description-more').click(function (e) {
              e.preventDefault();
              $(this).closest('.product-description-short').next().show();
              $(this).closest('.product-description-short').hide();
            });

            $('.product-description-less').click(function (e) {
              e.preventDefault();
              $(this).closest('.product-description-full').prev().show();
              $(this).closest('.product-description-full').hide();
            });
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  class RelatedSlider extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const relatedSlider = html.querySelector(`related-slider[data-id="${this.getAttribute('data-id')}"]`);
            if (relatedSlider && relatedSlider.innerHTML.trim().length) {
              this.innerHTML = relatedSlider.innerHTML;
            }

            /* Related products slider */
            const slider = this.querySelector('.related-slider__list');
            const prevBtn = this.querySelector('.related-slider__button-prev');
            const nextBtn = this.querySelector('.related-slider__button-next');
            const twoColumns = this.querySelector('.swiper-wrapper-2-mobile');
            const fiveDesktop = this.querySelector('.related-slider__list--desktop-5');
            if (twoColumns && document.querySelector('.related-slider__list')) {
              const productSlider = new Swiper(slider, {
                slidesPerView: 2,
                spaceBetween: 10,
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },
                breakpoints: {
                  750: {
                    slidesPerView: 2,
                  },
                  990: {
                    slidesPerView: 3,
                  },
                  1200: {
                    slidesPerView: fiveDesktop ? 5 : 4,
                  },
                },
              });
            } else if (document.querySelector('.related-slider__list')) {
              const productSlider = new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 10,
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },
                breakpoints: {
                  750: {
                    slidesPerView: 2,
                  },
                  990: {
                    slidesPerView: 3,
                  },
                  1200: {
                    slidesPerView: fiveDesktop ? 5 : 4,
                  },
                },
              });
            }

            /* Color swatches */
            const generateSrcset = (image, widths = []) => {
              const imageUrl = new URL(image['src']);
              return widths
                .filter((width) => width <= image['width'])
                .map((width) => {
                  imageUrl.searchParams.set('width', width.toString());
                  return `${imageUrl.href} ${width}w`;
                })
                .join(', ');
            };

            const createImageElement = (image, classes, sizes, productTitle) => {
              const previewImage = image['preview_image'];
              const newImage = new Image(previewImage['width'], previewImage['height']);
              newImage.className = classes;
              newImage.alt = image['alt'] || productTitle;
              newImage.sizes = sizes;
              newImage.src = previewImage['src'];
              newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
              newImage.loading = 'lazy';
              return newImage;
            };

            const checkSwatches = () => {
              document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
                wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
                  input.addEventListener('click', (event) => {
                    const primaryImage = wrapper.querySelector('.media--first');
                    const secondaryImage = wrapper.querySelector('.media--second');
                    const handleProduct = wrapper.dataset.product;

                    if (event.currentTarget.checked && primaryImage) {
                      wrapper
                        .querySelector('.js-color-swatches-link')
                        .setAttribute('href', event.currentTarget.dataset.variantLink);
                      if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"]')
                          .setAttribute('aria-disabled', false);
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"] > span')
                          .classList.remove('hidden');
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
                          .classList.add('hidden');
                        wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
                          event.currentTarget.dataset.variantId;
                      }

                      const currentColor = event.currentTarget.value;

                      jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
                        const variant = product.variants.filter(
                          (item) => item.featured_media != null && item.options.includes(currentColor)
                        )[0];

                        if (variant) {
                          const newPrimaryImage = createImageElement(
                            variant['featured_media'],
                            primaryImage.className,
                            primaryImage.sizes,
                            product.title
                          );

                          if (newPrimaryImage.src !== primaryImage.src) {
                            let flag = false;
                            if (secondaryImage) {
                              const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                              const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                              if (secondaryImagePathname == newPrimaryImagePathname) {
                                primaryImage.remove();
                                secondaryImage.classList.remove('media--second');
                                secondaryImage.classList.add('media--first');
                                flag = true;
                              }
                            }
                            if (flag == false) {
                              primaryImage.animate(
                                { opacity: [1, 0] },
                                { duration: 200, easing: 'ease-in', fill: 'forwards' }
                              ).finished;
                              setTimeout(function () {
                                primaryImage.replaceWith(newPrimaryImage);
                                newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: 'ease-in' });
                                if (secondaryImage) {
                                  secondaryImage.remove();
                                }
                              }, 200);
                            }
                          }
                        }
                      });
                    }
                  });
                });
              });
            };

            checkSwatches();
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  class TxMobileGalleryNav extends HTMLElement {
    constructor() {
      super();
      this.current = this.querySelector('[data-gallery-current]');
      this.prev = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.attempts = 0;
      this.connectToGallery();
    }

    connectToGallery() {
      const wrapper = this.closest('.product__media-wrapper');
      const gallery = wrapper ? wrapper.querySelector('.js-media-list') : null;
      if (!gallery) return;

      if (!gallery.swiper) {
        this.attempts += 1;
        if (this.attempts < 120) window.setTimeout(() => this.connectToGallery(), 50);
        return;
      }

      const swiper = gallery.swiper;
      const update = () => {
        if (this.current) this.current.textContent = String(swiper.realIndex + 1);
      };

      if (this.prev) this.prev.addEventListener('click', () => swiper.slidePrev());
      if (this.next) this.next.addEventListener('click', () => swiper.slideNext());
      swiper.on('slideChange', update);
      update();
    }
  }


  class TxMobileMediaGallery extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('[data-mobile-media-track]');
      this.slides = Array.from(this.querySelectorAll('[data-mobile-media-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-mobile-thumb]'));
      this.prev = this.querySelector('[data-mobile-prev]');
      this.next = this.querySelector('[data-mobile-next]');
      this.current = this.querySelector('[data-mobile-current]');
      this.index = 0;

      if (!this.track || !this.slides.length) return;

      this.prev?.addEventListener('click', () => this.goTo(this.index - 1));
      this.next?.addEventListener('click', () => this.goTo(this.index + 1));
      this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.mobileThumb))));

      let ticking = false;
      this.track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          const width = this.track.clientWidth || 1;
          const nextIndex = Math.round(this.track.scrollLeft / width);
          this.setActive(nextIndex);
          ticking = false;
        });
      }, { passive: true });

      this.setActive(0);
    }

    goTo(index) {
      const max = this.slides.length - 1;
      const target = Math.max(0, Math.min(max, index));
      this.slides[target]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      this.setActive(target);
    }

    setActive(index) {
      this.index = Math.max(0, Math.min(this.slides.length - 1, index));
      if (this.current) this.current.textContent = String(this.index + 1);
      this.thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === this.index));
      this.thumbs[this.index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  const initTxPdpRuntime = () => {
    document.querySelectorAll('.tx-pdp').forEach((section) => {
      if (section.dataset.txRuntimeReady === 'true') return;
      section.dataset.txRuntimeReady = 'true';

      /* Belt-and-suspenders: unhide every variant pill and drop any "show more" control, in case the shared snippet still emits them. */
      const txVariants = section.querySelector('.tx-variants');
      if (txVariants) {
        txVariants.querySelectorAll('input.hidden, label.hidden').forEach((el) => el.classList.remove('hidden'));
        txVariants.querySelectorAll('.js-show-more, .product-more').forEach((el) => el.remove());
      }

      let variantData = [];
      const variantJson = section.querySelector('[data-tx-variant-data]');
      if (variantJson) {
        try { variantData = JSON.parse(variantJson.textContent); } catch (error) { variantData = []; }
      }

      const productFormElement = section.querySelector('product-form');
      const mainForm = productFormElement?.querySelector('form[data-type="add-to-cart-form"]');
      const mainVariantInput = mainForm?.querySelector('input[name="id"]');
      const mainAddButton = mainForm?.querySelector('button[name="add"]');
      const mainAddLabel = mainAddButton?.querySelector('span');
      const quantityInput = mainForm?.querySelector('input[name="quantity"]');
      const errorWrapper = productFormElement?.querySelector('.product-form__error-message-wrapper');
      const errorText = errorWrapper?.querySelector('.product-form__error-message');
      const stockPill = section.querySelector('[id^="Inventory-"]');
      const skuElement = section.querySelector('[id^="Sku-"]');
      const inventoryNote = section.querySelector('[data-tx-inventory-note]');
      const inventoryHeading = section.querySelector('[data-tx-inventory-heading]');
      const inventoryMessage = section.querySelector('[data-tx-inventory-message]');
      const sticky = section.querySelector('[data-tx-sticky-atc]');
      const stickyButton = section.querySelector('[data-tx-sticky-add]');
      const stickyPrice = section.querySelector('[data-tx-sticky-price]');
      let submitting = false;

      const getVariant = () => {
        const id = Number(mainVariantInput?.value || 0);
        return variantData.find((variant) => Number(variant.id) === id) || null;
      };

      const showFormError = (message = '') => {
        if (!errorWrapper || !errorText) return;
        if (!message) {
          errorWrapper.hidden = true;
          errorWrapper.classList.remove('is-tx-visible');
          errorText.textContent = '';
          return;
        }
        errorText.textContent = message;
        errorWrapper.hidden = false;
        errorWrapper.classList.add('is-tx-visible');
      };

      const setSubmitting = (loading) => {
        submitting = loading;
        mainAddButton?.classList.toggle('is-tx-loading', loading);
        stickyButton?.classList.toggle('is-tx-loading', loading);

        const variant = getVariant();
        const unavailable = variant ? !variant.available : Boolean(mainAddButton?.disabled);

        if (mainAddButton) mainAddButton.disabled = loading || unavailable;
        if (stickyButton) stickyButton.disabled = loading || unavailable;

        if (loading) {
          if (mainAddLabel) mainAddLabel.textContent = 'Adding...';
          if (stickyButton) stickyButton.textContent = 'Adding...';
        } else {
          if (mainAddLabel) mainAddLabel.textContent = unavailable ? 'Sold Out' : 'Add to Cart';
          if (stickyButton) stickyButton.textContent = unavailable ? 'Sold Out' : 'Add to Cart';
        }
      };

      const getCartUi = () => {
        return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      };

      const refreshCartBubble = async () => {
        try {
          const root = window.Shopify?.routes?.root || '/';

          const response = await fetch(`${root}cart.js`, {
            method: 'GET',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            cache: 'no-store'
          });

          if (!response.ok) return;

          const cart = await response.json();
          const count = Number(cart.item_count || 0);

          /*
            Techno Express header + common Shopify/Dawn fallbacks.
            This changes ONLY the visible cart count.
          */
          document.querySelectorAll(
            '[data-cart-count], .cart-count .count, #cart-icon-bubble .cart-count .count, .cart-count-bubble span[aria-hidden="true"]'
          ).forEach((node) => {
            node.textContent = count;
            node.hidden = false;
          });

          /*
            If the bubble is hidden when cart = 0, reveal it
            once the first item is added.
          */
          document.querySelectorAll(
            '#cart-icon-bubble .cart-count, .cart-count, .cart-count-bubble'
          ).forEach((bubble) => {
            if (count > 0) {
              bubble.hidden = false;
              bubble.classList.remove('hidden');
            }
          });

        } catch (error) {
          console.warn('[Techno PDP] Cart bubble could not be refreshed.', error);
        }
      };

      const openUpdatedCart = (response) => {
        const cartUi = getCartUi();

        if (cartUi && typeof cartUi.renderContents === 'function' && response?.sections) {
          try {
            cartUi.renderContents(response);
            if (typeof cartUi.open === 'function') {
              window.setTimeout(() => cartUi.open(), 60);
            }
            return true;
          } catch (error) {
            console.warn('Techno PDP: cart UI render fallback used.', error);
          }
        }

        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { response } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        if (cartUi && typeof cartUi.open === 'function') {
          try { cartUi.open(); } catch (error) {}
        }

        return Boolean(cartUi);
      };

      const submitProduct = async () => {
        if (!mainForm || !mainVariantInput || !mainAddButton || submitting) return;

        showFormError('');

        if (typeof mainForm.reportValidity === 'function' && !mainForm.reportValidity()) {
          return;
        }

        const variant = getVariant();
        if (variant && !variant.available) {
          showFormError('This variant is currently unavailable.');
          return;
        }

        if (!mainVariantInput.value) {
          showFormError('Please select an available product option.');
          return;
        }

        setSubmitting(true);

        try {
          const formData = new FormData(mainForm);
          if (!formData.get('quantity')) formData.set('quantity', quantityInput?.value || '1');

          const cartUi = getCartUi();
          if (cartUi && typeof cartUi.getSectionsToRender === 'function') {
            const sectionIds = cartUi.getSectionsToRender()
              .map((item) => item?.id || item?.section)
              .filter(Boolean);
            if (sectionIds.length) formData.set('sections', sectionIds.join(','));
            formData.set('sections_url', window.location.pathname);
          } else {
            /* Common Techno/Dawn section handles. Shopify safely ignores unavailable handles. */
            formData.set('sections', 'cart-drawer,cart-icon-bubble');
            formData.set('sections_url', window.location.pathname);
          }

          const routeBase = window.routes?.cart_add_url || '/cart/add';
          const addUrl = routeBase.endsWith('.js') ? routeBase : `${routeBase}.js`;
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });

          const result = await response.json();
          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'The product could not be added to the cart.');
          }

          openUpdatedCart(result);

          /* Refresh ONLY the header cart bubble/count after a successful PDP add. */
          await refreshCartBubble();

          if (mainAddLabel) mainAddLabel.textContent = 'Added';
          if (stickyButton) stickyButton.textContent = 'Added';

          window.setTimeout(() => setSubmitting(false), 850);
        } catch (error) {
          console.error('Techno PDP add to cart error:', error);
          showFormError(error.message || 'The product could not be added to the cart. Please try again.');
          setSubmitting(false);
        }
      };

      const syncVariantUi = () => {
        const variant = getVariant();
        if (!variant) return;

        if (skuElement) {
          const value = skuElement.querySelector('span:last-child');
          if (value) value.textContent = variant.sku || '';
          skuElement.style.display = variant.sku ? 'inline-flex' : 'none';
        }

        if (stickyPrice) stickyPrice.textContent = variant.price || '';
        if (!submitting) {
          if (stickyButton) {
            stickyButton.disabled = !variant.available;
            stickyButton.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
          }
          if (mainAddButton) {
            mainAddButton.disabled = !variant.available;
            if (mainAddLabel) mainAddLabel.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
          }
        }

        if (stockPill) {
          stockPill.classList.toggle('is-sold-out', !variant.available);
          const textNode = Array.from(stockPill.childNodes).find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
          if (textNode) textNode.textContent = variant.available ? ' In Stock' : ' Out of Stock';
        }

        if (inventoryNote && inventoryHeading && inventoryMessage) {
          inventoryNote.classList.remove('is-in', 'is-low', 'is-backorder', 'is-out');
          let state = 'is-in';
          let heading = 'In Stock';
          let message = 'This variant is available to order.';

          if (!variant.available) {
            state = 'is-out';
            heading = 'Out of Stock';
            message = 'This variant is currently unavailable.';
          } else if (variant.inventory_management === 'shopify') {
            const quantity = Number(variant.inventory_quantity || 0);
            if (quantity <= 0 && variant.inventory_policy === 'continue') {
              state = 'is-backorder';
              heading = 'Available to Order';
              message = 'This variant can still be ordered while inventory is replenished.';
            } else if (quantity > 0 && quantity <= 5) {
              state = 'is-low';
              heading = 'Low Stock';
              message = `Only ${quantity} currently available.`;
            } else if (quantity > 5) {
              heading = 'In Stock';
              message = 'Inventory is available for this variant.';
            }
          }

          inventoryNote.classList.add(state);
          inventoryHeading.textContent = heading;
          inventoryMessage.textContent = message;
        }
      };

      /* We own this section's primary ATC submission so the main CTA and sticky CTA
         always use the exact same selected variant, quantity and line-item properties. */
      if (mainForm) {
        mainForm.addEventListener('submit', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          submitProduct();
        }, true);
      }

      if (stickyButton) {
        stickyButton.addEventListener('click', (event) => {
          event.preventDefault();
          submitProduct();
        });
      }

      section.addEventListener('change', () => {
        window.setTimeout(syncVariantUi, 0);
        window.setTimeout(syncVariantUi, 100);
        window.setTimeout(syncVariantUi, 300);
      });

      /* Desktop tabs for "Everything You Need to Know". The underlying
         markup stays the native <details>/<summary> accordions used on
         mobile; at >=990px we lay a tab strip on top of them and drive
         the same "open" attribute, so responsive behavior is unchanged. */
      const infoAccordionsWrap = section.querySelector('.tx-accordions');
      if (infoAccordionsWrap) {
        const infoAccordions = Array.from(infoAccordionsWrap.querySelectorAll(':scope > .tx-accordion'));
        infoAccordions.forEach((accordion) => {
          if (accordion.dataset.txDefaultOpen === undefined) {
            accordion.dataset.txDefaultOpen = accordion.hasAttribute('open') ? '1' : '0';
          }
        });

        const buildOrDestroyInfoTabs = () => {
          const isDesktop = window.matchMedia('(min-width: 990px)').matches;
          let tabNav = section.querySelector('.tx-info-tabs');

          if (!isDesktop) {
            if (tabNav) tabNav.remove();
            section.classList.remove('tx-tabs-ready');
            infoAccordions.forEach((accordion) => {
              if (accordion.dataset.txDefaultOpen === '1') accordion.setAttribute('open', '');
              else accordion.removeAttribute('open');
            });
            return;
          }

          if (!infoAccordions.length) return;

          if (!tabNav) {
            tabNav = document.createElement('div');
            tabNav.className = 'tx-info-tabs';
            tabNav.setAttribute('role', 'tablist');
            infoAccordionsWrap.parentNode.insertBefore(tabNav, infoAccordionsWrap);
          }
          tabNav.innerHTML = '';

          const activeAccordion = infoAccordions.find((el) => el.hasAttribute('open')) || infoAccordions[0];

          infoAccordions.forEach((accordion) => {
            const titleEl = accordion.querySelector('.tx-accordion__title');
            const iconEl = accordion.querySelector('.tx-accordion__icon');
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'tx-info-tabs__button';
            button.setAttribute('role', 'tab');
            if (iconEl) button.appendChild(iconEl.cloneNode(true));
            const label = document.createElement('span');
            label.textContent = titleEl ? titleEl.textContent.trim() : 'Details';
            button.appendChild(label);

            button.addEventListener('click', () => {
              infoAccordions.forEach((other) => other.removeAttribute('open'));
              accordion.setAttribute('open', '');
              tabNav.querySelectorAll('.tx-info-tabs__button').forEach((btn) => btn.classList.remove('is-active'));
              button.classList.add('is-active');
              accordion.scrollTop = 0;
            });

            if (accordion === activeAccordion) button.classList.add('is-active');
            tabNav.appendChild(button);
          });

          infoAccordions.forEach((accordion) => {
            if (accordion === activeAccordion) accordion.setAttribute('open', '');
            else accordion.removeAttribute('open');
          });

          section.classList.add('tx-tabs-ready');
        };

        buildOrDestroyInfoTabs();

        let infoTabsResizeTimer;
        window.addEventListener('resize', () => {
          window.clearTimeout(infoTabsResizeTimer);
          infoTabsResizeTimer = window.setTimeout(buildOrDestroyInfoTabs, 150);
        });
      }

      section.addEventListener('click', (event) => {
        const addButton = event.target.closest('[data-add-to-cart]');
        if (!addButton || addButton.disabled) return;
        event.preventDefault();

        const variantId = addButton.dataset.variantId;
        if (!variantId) return;

        addButton.disabled = true;
        const originalLabel = addButton.textContent;
        const croError = addButton.closest('.cro-accessory')?.querySelector('[data-cro-addon-error]');
        if(croError) croError.hidden=true;
        addButton.textContent = 'Adding...';

        const formData = new FormData();
        formData.set('id', variantId);
        formData.set('quantity', '1');

        const cartUi = getCartUi();
        if (cartUi && typeof cartUi.getSectionsToRender === 'function') {
          const sectionIds = cartUi.getSectionsToRender()
            .map((item) => item?.id || item?.section)
            .filter(Boolean);
          if (sectionIds.length) formData.set('sections', sectionIds.join(','));
          formData.set('sections_url', window.location.pathname);
        } else {
          formData.set('sections', 'cart-drawer,cart-icon-bubble');
          formData.set('sections_url', window.location.pathname);
        }

        const routeBase = window.routes?.cart_add_url || '/cart/add';
        const addUrl = routeBase.endsWith('.js') ? routeBase : `${routeBase}.js`;

        fetch(addUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        })
          .then((response) => response.json())
          .then((result) => {
            if (result.status) {
              throw new Error(result.description || result.message || 'The product could not be added to the cart.');
            }
            openUpdatedCart(result);
            return refreshCartBubble();
          })
          .then(() => {
            addButton.textContent = 'Added';
            window.setTimeout(() => {
              addButton.textContent = originalLabel;
              addButton.disabled = false;
            }, 1200);
          })
          .catch((error) => {
            if(croError){croError.textContent=error.message || 'Could not add this item. Please try again.';croError.hidden=false;}
            console.error('Techno merch quick add error:', error);
            addButton.textContent = originalLabel;
            addButton.disabled = false;
          });
      });

      if (sticky && mainAddButton && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          const passedAboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', passedAboveViewport);
          sticky.setAttribute('aria-hidden', passedAboveViewport ? 'false' : 'true');
        }, { threshold: 0.05 });
        observer.observe(mainAddButton);
      }

      syncVariantUi();
    });
  };

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
  if (!customElements.get('tx-mobile-gallery-nav')) customElements.define('tx-mobile-gallery-nav', TxMobileGalleryNav);
  if (!customElements.get('tx-mobile-media-gallery')) customElements.define('tx-mobile-media-gallery', TxMobileMediaGallery);
  if (!customElements.get('related-product')) customElements.define('related-product', RelatedProduct);
  if (!customElements.get('related-slider')) customElements.define('related-slider', RelatedSlider);
  initTxPdpRuntime();
  document.addEventListener('shopify:section:load', initTxPdpRuntime);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mainpropuesta-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();

      const overlay = this.querySelector('[data-modal-overlay]');
      if (overlay) overlay.addEventListener('click', () => this.hide());

      this.querySelectorAll('[data-modal-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          this.showActiveMedia(thumb.getAttribute('data-media-id'));
        });
      });
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia(this.openedBy.getAttribute('data-media-id'));
    }

    showActiveMedia(mediaId) {
      const activeMedia = this.querySelector(`.product-media-modal__content [data-media-id="${mediaId}"]`);
      if (!activeMedia) return;

      this.querySelectorAll('.product-media-modal__content [data-media-id]').forEach((element) => {
        element.classList.toggle('active', element === activeMedia);
      });

      this.querySelectorAll('[data-modal-thumb]').forEach((thumb) => {
        const isActive = thumb.getAttribute('data-media-id') === mediaId;
        thumb.classList.toggle('is-active', isActive);
        if (isActive) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });

      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  class RelatedProduct extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const related = html.querySelector('.related-product');
            if (related && related.innerHTML.trim().length) {
              this.innerHTML = related.innerHTML;
            }

            /* Toggle content */
            $('.product-description-more').click(function (e) {
              e.preventDefault();
              $(this).closest('.product-description-short').next().show();
              $(this).closest('.product-description-short').hide();
            });

            $('.product-description-less').click(function (e) {
              e.preventDefault();
              $(this).closest('.product-description-full').prev().show();
              $(this).closest('.product-description-full').hide();
            });
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  class RelatedSlider extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const relatedSlider = html.querySelector(`related-slider[data-id="${this.getAttribute('data-id')}"]`);
            if (relatedSlider && relatedSlider.innerHTML.trim().length) {
              this.innerHTML = relatedSlider.innerHTML;
            }

            /* Related products slider */
            const slider = this.querySelector('.related-slider__list');
            const prevBtn = this.querySelector('.related-slider__button-prev');
            const nextBtn = this.querySelector('.related-slider__button-next');
            const twoColumns = this.querySelector('.swiper-wrapper-2-mobile');
            const fiveDesktop = this.querySelector('.related-slider__list--desktop-5');
            if (twoColumns && document.querySelector('.related-slider__list')) {
              const productSlider = new Swiper(slider, {
                slidesPerView: 2,
                spaceBetween: 10,
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },
                breakpoints: {
                  750: {
                    slidesPerView: 2,
                  },
                  990: {
                    slidesPerView: 3,
                  },
                  1200: {
                    slidesPerView: fiveDesktop ? 5 : 4,
                  },
                },
              });
            } else if (document.querySelector('.related-slider__list')) {
              const productSlider = new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 10,
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },
                breakpoints: {
                  750: {
                    slidesPerView: 2,
                  },
                  990: {
                    slidesPerView: 3,
                  },
                  1200: {
                    slidesPerView: fiveDesktop ? 5 : 4,
                  },
                },
              });
            }

            /* Color swatches */
            const generateSrcset = (image, widths = []) => {
              const imageUrl = new URL(image['src']);
              return widths
                .filter((width) => width <= image['width'])
                .map((width) => {
                  imageUrl.searchParams.set('width', width.toString());
                  return `${imageUrl.href} ${width}w`;
                })
                .join(', ');
            };

            const createImageElement = (image, classes, sizes, productTitle) => {
              const previewImage = image['preview_image'];
              const newImage = new Image(previewImage['width'], previewImage['height']);
              newImage.className = classes;
              newImage.alt = image['alt'] || productTitle;
              newImage.sizes = sizes;
              newImage.src = previewImage['src'];
              newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
              newImage.loading = 'lazy';
              return newImage;
            };

            const checkSwatches = () => {
              document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
                wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
                  input.addEventListener('click', (event) => {
                    const primaryImage = wrapper.querySelector('.media--first');
                    const secondaryImage = wrapper.querySelector('.media--second');
                    const handleProduct = wrapper.dataset.product;

                    if (event.currentTarget.checked && primaryImage) {
                      wrapper
                        .querySelector('.js-color-swatches-link')
                        .setAttribute('href', event.currentTarget.dataset.variantLink);
                      if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"]')
                          .setAttribute('aria-disabled', false);
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"] > span')
                          .classList.remove('hidden');
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
                          .classList.add('hidden');
                        wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
                          event.currentTarget.dataset.variantId;
                      }

                      const currentColor = event.currentTarget.value;

                      jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
                        const variant = product.variants.filter(
                          (item) => item.featured_media != null && item.options.includes(currentColor)
                        )[0];

                        if (variant) {
                          const newPrimaryImage = createImageElement(
                            variant['featured_media'],
                            primaryImage.className,
                            primaryImage.sizes,
                            product.title
                          );

                          if (newPrimaryImage.src !== primaryImage.src) {
                            let flag = false;
                            if (secondaryImage) {
                              const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                              const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                              if (secondaryImagePathname == newPrimaryImagePathname) {
                                primaryImage.remove();
                                secondaryImage.classList.remove('media--second');
                                secondaryImage.classList.add('media--first');
                                flag = true;
                              }
                            }
                            if (flag == false) {
                              primaryImage.animate(
                                { opacity: [1, 0] },
                                { duration: 200, easing: 'ease-in', fill: 'forwards' }
                              ).finished;
                              setTimeout(function () {
                                primaryImage.replaceWith(newPrimaryImage);
                                newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: 'ease-in' });
                                if (secondaryImage) {
                                  secondaryImage.remove();
                                }
                              }, 200);
                            }
                          }
                        }
                      });
                    }
                  });
                });
              });
            };

            checkSwatches();
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  class TxMobileGalleryNav extends HTMLElement {
    constructor() {
      super();
      this.current = this.querySelector('[data-gallery-current]');
      this.prev = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.attempts = 0;
      this.connectToGallery();
    }

    connectToGallery() {
      const wrapper = this.closest('.product__media-wrapper');
      const gallery = wrapper ? wrapper.querySelector('.js-media-list') : null;
      if (!gallery) return;

      if (!gallery.swiper) {
        this.attempts += 1;
        if (this.attempts < 120) window.setTimeout(() => this.connectToGallery(), 50);
        return;
      }

      const swiper = gallery.swiper;
      const update = () => {
        if (this.current) this.current.textContent = String(swiper.realIndex + 1);
      };

      if (this.prev) this.prev.addEventListener('click', () => swiper.slidePrev());
      if (this.next) this.next.addEventListener('click', () => swiper.slideNext());
      swiper.on('slideChange', update);
      update();
    }
  }


  class TxMobileMediaGallery extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('[data-mobile-media-track]');
      this.slides = Array.from(this.querySelectorAll('[data-mobile-media-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-mobile-thumb]'));
      this.prev = this.querySelector('[data-mobile-prev]');
      this.next = this.querySelector('[data-mobile-next]');
      this.current = this.querySelector('[data-mobile-current]');
      this.index = 0;

      if (!this.track || !this.slides.length) return;

      this.prev?.addEventListener('click', () => this.goTo(this.index - 1));
      this.next?.addEventListener('click', () => this.goTo(this.index + 1));
      this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.mobileThumb))));

      let ticking = false;
      this.track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          const width = this.track.clientWidth || 1;
          const nextIndex = Math.round(this.track.scrollLeft / width);
          this.setActive(nextIndex);
          ticking = false;
        });
      }, { passive: true });

      this.setActive(0);
    }

    goTo(index) {
      const max = this.slides.length - 1;
      const target = Math.max(0, Math.min(max, index));
      this.slides[target]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      this.setActive(target);
    }

    setActive(index) {
      this.index = Math.max(0, Math.min(this.slides.length - 1, index));
      if (this.current) this.current.textContent = String(this.index + 1);
      this.thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === this.index));
      this.thumbs[this.index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  const initTxPdpRuntime = () => {
    document.querySelectorAll('.tx-pdp').forEach((section) => {
      if (section.dataset.txRuntimeReady === 'true') return;
      section.dataset.txRuntimeReady = 'true';

      /* Belt-and-suspenders: unhide every variant pill and drop any "show more" control, in case the shared snippet still emits them. */
      const txVariants = section.querySelector('.tx-variants');
      if (txVariants) {
        txVariants.querySelectorAll('input.hidden, label.hidden').forEach((el) => el.classList.remove('hidden'));
        txVariants.querySelectorAll('.js-show-more, .product-more').forEach((el) => el.remove());
      }

      let variantData = [];
      const variantJson = section.querySelector('[data-tx-variant-data]');
      if (variantJson) {
        try { variantData = JSON.parse(variantJson.textContent); } catch (error) { variantData = []; }
      }

      const productFormElement = section.querySelector('product-form');
      const mainForm = productFormElement?.querySelector('form[data-type="add-to-cart-form"]');
      const mainVariantInput = mainForm?.querySelector('input[name="id"]');
      const mainAddButton = mainForm?.querySelector('button[name="add"]');
      const mainAddLabel = mainAddButton?.querySelector('span');
      const quantityInput = mainForm?.querySelector('input[name="quantity"]');
      const errorWrapper = productFormElement?.querySelector('.product-form__error-message-wrapper');
      const errorText = errorWrapper?.querySelector('.product-form__error-message');
      const stockPill = section.querySelector('[id^="Inventory-"]');
      const skuElement = section.querySelector('[id^="Sku-"]');
      const inventoryNote = section.querySelector('[data-tx-inventory-note]');
      const inventoryHeading = section.querySelector('[data-tx-inventory-heading]');
      const inventoryMessage = section.querySelector('[data-tx-inventory-message]');
      const sticky = section.querySelector('[data-tx-sticky-atc]');
      const stickyButton = section.querySelector('[data-tx-sticky-add]');
      const stickyPrice = section.querySelector('[data-tx-sticky-price]');
      let submitting = false;

      const croOptions = section.querySelector('[data-cro-options]');
      const getVariant = () => {
        const id = Number(mainVariantInput?.value || 0);
        return variantData.find((variant) => Number(variant.id) === id) || null;
      };

      const showFormError = (message = '') => {
        if (!errorWrapper || !errorText) return;
        if (!message) {
          errorWrapper.hidden = true;
          errorWrapper.classList.remove('is-tx-visible');
          errorText.textContent = '';
          return;
        }
        errorText.textContent = message;
        errorWrapper.hidden = false;
        errorWrapper.classList.add('is-tx-visible');
      };

      const setSubmitting = (loading) => {
        submitting = loading;
        mainAddButton?.classList.toggle('is-tx-loading', loading);
        stickyButton?.classList.toggle('is-tx-loading', loading);

        const variant = getVariant();
        const unavailable = variant ? !variant.available : Boolean(mainAddButton?.disabled);

        if (mainAddButton) mainAddButton.disabled = loading || unavailable;
        if (stickyButton) stickyButton.disabled = loading || unavailable;

        if (loading) {
          if (mainAddLabel) mainAddLabel.textContent = 'Adding...';
          if (stickyButton) stickyButton.textContent = 'Adding...';
        } else {
          if (mainAddLabel) mainAddLabel.textContent = unavailable ? 'Sold Out' : 'Add to Cart';
          if (stickyButton) stickyButton.textContent = unavailable ? 'Sold Out' : 'Add to Cart';
        }
      };

      const getCartUi = () => {
        return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      };

      const refreshCartBubble = async () => {
        try {
          const root = window.Shopify?.routes?.root || '/';

          const response = await fetch(`${root}cart.js`, {
            method: 'GET',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            cache: 'no-store'
          });

          if (!response.ok) return;

          const cart = await response.json();
          const croShipping = section.querySelector('[data-cro-shipping]');
          if (croShipping) { croShipping.dataset.cartTotal = String(cart.total_price || 0); updateCroSummary(); }
          const count = Number(cart.item_count || 0);

          /*
            Techno Express header + common Shopify/Dawn fallbacks.
            This changes ONLY the visible cart count.
          */
          document.querySelectorAll(
            '[data-cart-count], .cart-count .count, #cart-icon-bubble .cart-count .count, .cart-count-bubble span[aria-hidden="true"]'
          ).forEach((node) => {
            node.textContent = count;
            node.hidden = false;
          });

          /*
            If the bubble is hidden when cart = 0, reveal it
            once the first item is added.
          */
          document.querySelectorAll(
            '#cart-icon-bubble .cart-count, .cart-count, .cart-count-bubble'
          ).forEach((bubble) => {
            if (count > 0) {
              bubble.hidden = false;
              bubble.classList.remove('hidden');
            }
          });

        } catch (error) {
          console.warn('[Techno PDP] Cart bubble could not be refreshed.', error);
        }
      };

      const openUpdatedCart = (response) => {
        const cartUi = getCartUi();

        if (cartUi && typeof cartUi.renderContents === 'function' && response?.sections) {
          try {
            cartUi.renderContents(response);
            if (typeof cartUi.open === 'function') {
              window.setTimeout(() => cartUi.open(), 60);
            }
            return true;
          } catch (error) {
            console.warn('Techno PDP: cart UI render fallback used.', error);
          }
        }

        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { response } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        if (cartUi && typeof cartUi.open === 'function') {
          try { cartUi.open(); } catch (error) {}
        }

        return Boolean(cartUi);
      };

      const submitProduct = async () => {
        if (!mainForm || !mainVariantInput || !mainAddButton || submitting) return;

        showFormError('');
        if (croOptions && !getVariant()) { showFormError('Please select an available color and pack size.'); return; }

        if (typeof mainForm.reportValidity === 'function' && !mainForm.reportValidity()) {
          return;
        }

        const variant = getVariant();
        if (variant && !variant.available) {
          showFormError('This variant is currently unavailable.');
          return;
        }

        if (!mainVariantInput.value) {
          showFormError('Please select an available product option.');
          return;
        }

        setSubmitting(true);

        try {
          const formData = new FormData(mainForm);
          if (!formData.get('quantity')) formData.set('quantity', quantityInput?.value || '1');

          const cartUi = getCartUi();
          if (cartUi && typeof cartUi.getSectionsToRender === 'function') {
            const sectionIds = cartUi.getSectionsToRender()
              .map((item) => item?.id || item?.section)
              .filter(Boolean);
            if (sectionIds.length) formData.set('sections', sectionIds.join(','));
            formData.set('sections_url', window.location.pathname);
          } else {
            /* Common Techno/Dawn section handles. Shopify safely ignores unavailable handles. */
            formData.set('sections', 'cart-drawer,cart-icon-bubble');
            formData.set('sections_url', window.location.pathname);
          }

          const routeBase = window.routes?.cart_add_url || '/cart/add';
          const addUrl = routeBase.endsWith('.js') ? routeBase : `${routeBase}.js`;
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });

          const result = await response.json();
          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'The product could not be added to the cart.');
          }

          const cartWasOpened = openUpdatedCart(result);
          if (!cartWasOpened) window.location.assign(window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`);

          /* Refresh ONLY the header cart bubble/count after a successful PDP add. */
          await refreshCartBubble();

          if (mainAddLabel) mainAddLabel.textContent = 'Added';
          if (stickyButton) stickyButton.textContent = 'Added';

          window.setTimeout(() => setSubmitting(false), 850);
        } catch (error) {
          console.error('Techno PDP add to cart error:', error);
          showFormError(error.message || 'The product could not be added to the cart. Please try again.');
          setSubmitting(false);
        }
      };

      const syncVariantUi = () => {
        const variant = getVariant();
        if (!variant) return;

        if (skuElement) {
          const value = skuElement.querySelector('span:last-child');
          if (value) value.textContent = variant.sku || '';
          skuElement.style.display = variant.sku ? 'inline-flex' : 'none';
        }

        if (stickyPrice) stickyPrice.textContent = croOptions ? `${variant.options.join(' / ')} · ${variant.price || ''}` : variant.price || '';
        if (!submitting) {
          if (stickyButton) {
            stickyButton.disabled = !variant.available;
            stickyButton.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
          }
          if (mainAddButton) {
            mainAddButton.disabled = !variant.available;
            if (mainAddLabel) mainAddLabel.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
          }
        }

        if (stockPill) {
          stockPill.classList.toggle('is-sold-out', !variant.available);
          const textNode = Array.from(stockPill.childNodes).find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
          if (textNode) textNode.textContent = variant.available ? (variant.inventory_management === 'shopify' && variant.inventory_quantity <= 0 && variant.inventory_policy === 'continue' ? ' Available to order' : ' In Stock') : ' Out of Stock';
        }

        if (inventoryNote && inventoryHeading && inventoryMessage) {
          inventoryNote.classList.remove('is-in', 'is-low', 'is-backorder', 'is-out');
          let state = 'is-in';
          let heading = 'In Stock';
          let message = 'This variant is available to order.';

          if (!variant.available) {
            state = 'is-out';
            heading = 'Out of Stock';
            message = 'This variant is currently unavailable.';
          } else if (variant.inventory_management === 'shopify') {
            const quantity = Number(variant.inventory_quantity || 0);
            if (quantity <= 0 && variant.inventory_policy === 'continue') {
              state = 'is-backorder';
              heading = 'Available to Order';
              message = 'This variant can still be ordered while inventory is replenished.';
            } else if (quantity > 0 && quantity <= 5) {
              state = 'is-low';
              heading = 'Low Stock';
              message = `Only ${quantity} currently available.`;
            } else if (quantity > 5) {
              heading = 'In Stock';
              message = 'Inventory is available for this variant.';
            }
          }

          inventoryNote.classList.add(state);
          inventoryHeading.textContent = heading;
          inventoryMessage.textContent = message;
        }
      };


      const croShipping = section.querySelector('[data-cro-shipping]');
      const money = (cents) => new Intl.NumberFormat(section.dataset.croLocale || 'en-US', {style:'currency',currency:section.dataset.croCurrency || 'USD'}).format(cents / 100);
      const packCount = (variant) => {
        const pack = (variant?.options || []).find(value => /\bpack\b|single/i.test(value)) || '';
        const match = pack.match(/\d+/);
        return match ? Math.max(1, Number(match[0])) : 1;
      };
      const updateCroSummary = () => {
        if (!croOptions) return;
        const variant = getVariant();
        const summary = section.querySelector('[data-cro-selection]');
        if (!variant) { if(summary) summary.textContent='This combination is not available. Choose another option.'; return; }
        const size=packCount(variant);
        const qty=Math.max(1, Number(quantityInput?.value || 1));
        const total=size*qty;
        const selected=section.querySelector('[data-cro-pack]');
        const color=section.querySelector('[data-cro-color]');
        const colorOption=(variant.options || []).find(value=>/^(red|black|blue)$/i.test(value));
        const packOption=(variant.options || []).find(value=>/pack|single/i.test(value));
        if(selected) selected.textContent=packOption || variant.options.join(' / ');
        if(color) color.textContent=colorOption || '';
        if(summary) summary.textContent=`${qty} ${qty===1?'pack':'packs'} × ${size} ${size===1?'jumper':'jumpers'} = ${total} ${total===1?'jumper':'jumpers'} · ${money(variant.price_raw*qty)} total · ${money(variant.price_raw/size)} per jumper`;
        const included=section.querySelector('[data-cro-included]');
        if(included) included.textContent=`${total} pre-made ${colorOption || ''} 14 AWG marine ${total===1?'jumper':'jumpers'} in ${qty} selected ${qty===1?'pack':'packs'}.`;
        if(croShipping) {
          const threshold=Number(croShipping.dataset.threshold || 15000);
          // Use the current cart total only; adding a product is required before progress changes.
          const subtotal=Number(croShipping.dataset.cartTotal || 0);
          const remaining=Math.max(0,threshold-subtotal);
          const label=croShipping.querySelector('[data-cro-shipping-label]');
          const bar=croShipping.querySelector('[data-cro-progress]');
          if(label) label.textContent=subtotal>threshold?'Your cart exceeds the free-shipping minimum. Qualifying orders only.':remaining>0?`Add ${money(remaining)} more to your cart to reach the free-shipping minimum.`:'You have reached the minimum. Free shipping applies to qualifying orders over this amount.';
          if(bar) bar.style.width=`${Math.min(100,Math.max(0,threshold>0?subtotal/threshold*100:0))}%`;
        }
      };
      const applyCroOptions = (changeMedia=true) => {
        if (!croOptions) return;
        const groups=Array.from(croOptions.querySelectorAll('[data-cro-option]'));
        const selected=groups.map(group=>group.querySelector('input:checked')?.value || '');
        const variant=variantData.find(item=>item.options?.every((value,index)=>value===selected[index]));
        if(!variant) {
          if(mainVariantInput) {mainVariantInput.value='';mainVariantInput.disabled=true;}
          if(mainAddButton) mainAddButton.disabled=true;
          if(stickyButton) stickyButton.disabled=true;
          if(mainAddLabel) mainAddLabel.textContent='Unavailable';
          updateCroSummary();return;
        }
        mainVariantInput.value=String(variant.id);mainVariantInput.disabled=!variant.available;
        const price=section.querySelector('[id^="price-"]');
        if(price) {
          price.replaceChildren();
          const regular=document.createElement('span');regular.className='cro-current-price';regular.textContent=variant.price;price.append(regular);
          if(variant.compare_raw>variant.price_raw){const compare=document.createElement('s');compare.className='cro-compare-price';compare.textContent=variant.compare_price;price.append(compare);}
        }
        if(quantityInput) {
          quantityInput.min=String(variant.quantity_min || 1);quantityInput.step=String(variant.quantity_step || 1);
          if(variant.quantity_max!=null)quantityInput.max=String(variant.quantity_max);else quantityInput.removeAttribute('max');
          quantityInput.dataset.min=quantityInput.min;
          if(variant.quantity_max!=null)quantityInput.dataset.max=quantityInput.max;else delete quantityInput.dataset.max;
          let quantity=Number(quantityInput.value || variant.quantity_min || 1);
          quantity=Math.max(variant.quantity_min || 1,quantity);
          if(variant.quantity_max!=null) quantity=Math.min(quantity,variant.quantity_max);
          const min=variant.quantity_min || 1,step=variant.quantity_step || 1;
          quantity=min+Math.floor((quantity-min)/step)*step;
          quantityInput.value=String(quantity);
        }
        groups.forEach((group,index)=>group.querySelectorAll('input').forEach(input=>{
          const possible=variantData.some(item=>item.available&&item.options?.every((value,i)=>value===(i===index?input.value:selected[i])));
          input.nextElementSibling?.classList.toggle('is-unavailable',!possible);
          input.title=possible?'':'Unavailable with the other selected option';
        }));
        const url=new URL(window.location.href);url.searchParams.set('variant',variant.id);window.history.replaceState({},'',url);
        syncVariantUi();updateCroSummary();showFormError('');
        if(changeMedia&&variant.media_id) {
          const swiper=section.querySelector('.js-media-list')?.swiper;
          if(swiper) {
            const index=Array.from(swiper.slides).findIndex(slide=>String(slide.dataset.mediaId || '').endsWith(String(variant.media_id)));
            if(index>=0)swiper.slideTo(index);
          }
          const mobile=section.querySelector('tx-mobile-media-gallery');
          const slides=Array.from(section.querySelectorAll('[data-mobile-media-slide]'));
          const index=slides.findIndex(slide=>String(slide.dataset.croMediaId)===String(variant.media_id));
          if(index>=0&&typeof mobile?.goTo==='function')mobile.goTo(index);
        }
      };
      if(croOptions) {
        croOptions.addEventListener('change',()=>applyCroOptions());
        quantityInput?.addEventListener('input',updateCroSummary);
        quantityInput?.addEventListener('change',updateCroSummary);
        // Already selected variant is respected, including variant deep links.
        applyCroOptions(false);
        document.addEventListener('cart:updated',()=>refreshCartBubble());
        document.addEventListener('cart:refresh',()=>refreshCartBubble());
      }

      /* We own this section's primary ATC submission so the main CTA and sticky CTA
         always use the exact same selected variant, quantity and line-item properties. */
      if (mainForm) {
        mainForm.addEventListener('submit', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          submitProduct();
        }, true);
      }

      if (stickyButton) {
        stickyButton.addEventListener('click', (event) => {
          event.preventDefault();
          submitProduct();
        });
      }

      section.addEventListener('change', () => {
        window.setTimeout(syncVariantUi, 0);
        window.setTimeout(syncVariantUi, 100);
        window.setTimeout(syncVariantUi, 300);
      });

      /* Desktop tabs for "Everything You Need to Know". The underlying
         markup stays the native <details>/<summary> accordions used on
         mobile; at >=990px we lay a tab strip on top of them and drive
         the same "open" attribute, so responsive behavior is unchanged. */
      const infoAccordionsWrap = section.querySelector('.tx-accordions');
      if (infoAccordionsWrap) {
        const infoAccordions = Array.from(infoAccordionsWrap.querySelectorAll(':scope > .tx-accordion'));
        infoAccordions.forEach((accordion) => {
          if (accordion.dataset.txDefaultOpen === undefined) {
            accordion.dataset.txDefaultOpen = accordion.hasAttribute('open') ? '1' : '0';
          }
        });

        const buildOrDestroyInfoTabs = () => {
          const isDesktop = window.matchMedia('(min-width: 990px)').matches;
          let tabNav = section.querySelector('.tx-info-tabs');

          if (!isDesktop) {
            if (tabNav) tabNav.remove();
            section.classList.remove('tx-tabs-ready');
            infoAccordions.forEach((accordion) => {
              if (accordion.dataset.txDefaultOpen === '1') accordion.setAttribute('open', '');
              else accordion.removeAttribute('open');
            });
            return;
          }

          if (!infoAccordions.length) return;

          if (!tabNav) {
            tabNav = document.createElement('div');
            tabNav.className = 'tx-info-tabs';
            tabNav.setAttribute('role', 'tablist');
            infoAccordionsWrap.parentNode.insertBefore(tabNav, infoAccordionsWrap);
          }
          tabNav.innerHTML = '';

          const activeAccordion = infoAccordions.find((el) => el.hasAttribute('open')) || infoAccordions[0];

          infoAccordions.forEach((accordion) => {
            const titleEl = accordion.querySelector('.tx-accordion__title');
            const iconEl = accordion.querySelector('.tx-accordion__icon');
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'tx-info-tabs__button';
            button.setAttribute('role', 'tab');
            if (iconEl) button.appendChild(iconEl.cloneNode(true));
            const label = document.createElement('span');
            label.textContent = titleEl ? titleEl.textContent.trim() : 'Details';
            button.appendChild(label);

            button.addEventListener('click', () => {
              infoAccordions.forEach((other) => other.removeAttribute('open'));
              accordion.setAttribute('open', '');
              tabNav.querySelectorAll('.tx-info-tabs__button').forEach((btn) => btn.classList.remove('is-active'));
              button.classList.add('is-active');
              accordion.scrollTop = 0;
            });

            if (accordion === activeAccordion) button.classList.add('is-active');
            tabNav.appendChild(button);
          });

          infoAccordions.forEach((accordion) => {
            if (accordion === activeAccordion) accordion.setAttribute('open', '');
            else accordion.removeAttribute('open');
          });

          section.classList.add('tx-tabs-ready');
        };

        buildOrDestroyInfoTabs();

        let infoTabsResizeTimer;
        window.addEventListener('resize', () => {
          window.clearTimeout(infoTabsResizeTimer);
          infoTabsResizeTimer = window.setTimeout(buildOrDestroyInfoTabs, 150);
        });
      }

      section.addEventListener('click', (event) => {
        const addButton = event.target.closest('[data-add-to-cart]');
        if (!addButton || addButton.disabled) return;
        event.preventDefault();

        const variantId = addButton.dataset.variantId;
        if (!variantId) return;

        addButton.disabled = true;
        const originalLabel = addButton.textContent;
        const addonError = addButton.closest('.cro-accessory')?.querySelector('[data-cro-addon-error]');
        if (addonError) addonError.hidden = true;
        addButton.textContent = 'Adding...';

        const formData = new FormData();
        formData.set('id', variantId);
        formData.set('quantity', '1');

        const cartUi = getCartUi();
        if (cartUi && typeof cartUi.getSectionsToRender === 'function') {
          const sectionIds = cartUi.getSectionsToRender()
            .map((item) => item?.id || item?.section)
            .filter(Boolean);
          if (sectionIds.length) formData.set('sections', sectionIds.join(','));
          formData.set('sections_url', window.location.pathname);
        } else {
          formData.set('sections', 'cart-drawer,cart-icon-bubble');
          formData.set('sections_url', window.location.pathname);
        }

        const routeBase = window.routes?.cart_add_url || '/cart/add';
        const addUrl = routeBase.endsWith('.js') ? routeBase : `${routeBase}.js`;

        fetch(addUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        })
          .then((response) => response.json())
          .then((result) => {
            if (result.status) {
              throw new Error(result.description || result.message || 'The product could not be added to the cart.');
            }
            openUpdatedCart(result);
            return refreshCartBubble();
          })
          .then(() => {
            addButton.textContent = 'Added';
            window.setTimeout(() => {
              addButton.textContent = originalLabel;
              addButton.disabled = false;
            }, 1200);
          })
          .catch((error) => {
            if (addonError) { addonError.textContent = error.message || 'Could not add this item. Please try again.'; addonError.hidden = false; }
            console.error('Techno merch quick add error:', error);
            addButton.textContent = originalLabel;
            addButton.disabled = false;
          });
      });

      if (sticky && mainAddButton && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          const passedAboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', passedAboveViewport);
          sticky.setAttribute('aria-hidden', passedAboveViewport ? 'false' : 'true');
          sticky.inert = !passedAboveViewport;
        }, { threshold: 0.05 });
        observer.observe(mainAddButton);
      }

      syncVariantUi();
    });
  };

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
  if (!customElements.get('tx-mobile-gallery-nav')) customElements.define('tx-mobile-gallery-nav', TxMobileGalleryNav);
  if (!customElements.get('tx-mobile-media-gallery')) customElements.define('tx-mobile-media-gallery', TxMobileMediaGallery);
  if (!customElements.get('related-product')) customElements.define('related-product', RelatedProduct);
  if (!customElements.get('related-slider')) customElements.define('related-slider', RelatedSlider);
  initTxPdpRuntime();
  document.addEventListener('shopify:section:load', initTxPdpRuntime);

  } catch(e) { console.error(e); }
})();
})();
